import { BookingTime } from "../enums/booking-time.enum";

export class BookingDate {
  date: number;
  time: BookingTime;

  constructor(date: number, time: BookingTime) {
    this.date = date;
    this.time = time;
  }

  getBookingDateStrings(bookingDates: BookingDate[]): string {
    let dateString = '';
    bookingDates.forEach(b => {
      let date = new Date(b.date);
      dateString += date.toLocaleDateString() + ', ' + b.time + '<br>'
    });
    return dateString;
  }

  public static mapFromFirestore(bookingDate: any): BookingDate {
    return new BookingDate(
      bookingDate.date,
      bookingDate.time
    );
  }

  public mapToFirestore(): any {
    return {
      date: this.date,
      time: this.time,
    };
  }

  public static mapArrayFromFirestore(bookingDates: any[]): BookingDate[] {
    var bookingDatesArray = [];
    if (bookingDates) {
      bookingDates.forEach((bookingDate: any) => {
        bookingDatesArray.push(BookingDate.mapFromFirestore(bookingDate));
      });
    }
    return bookingDatesArray;
  }

  public static mapArrayToFirestore(bookingDates: BookingDate[]): any {
    var bookingDatesArray = [];
    bookingDates.forEach((bookingDate: BookingDate) => {
      bookingDatesArray.push(bookingDate.mapToFirestore());
    });
    return bookingDatesArray;
  }
}
